/* erstelle ein Version-Json datei */
const versionData = [
  {
    version: "1.0.55-Beta",
    releaseDate: "2026-08-08",
    releaseContent: [
      "feat: Add Search component for event searching functionality",
      "feat: Create Version data file to track application releases",
      "chore: Add TypeScript environment definitions",
      "chore: Implement web vitals reporting for performance monitoring",
      "fix: Adjust margins and widths for calendar container responsiveness",
      "fix: Update paths for icons and homepage in configuration files"

    ],
  },
  {
    version: "1.0.52-Beta",
    releaseDate: "2026-03-05",
    releaseContent: [
      "feat: Add Search component for event searching functionality",
      "feat: Create Version data file to track application releases",
      "chore: Add TypeScript environment definitions",
      "chore: Implement web vitals reporting for performance monitoring",
    ],
  },
  {
    version: "1.0.50-Beta",
    releaseDate: "2026-03-02",
    releaseContent: [
      "feat: Add Footer component to Home page and update version data with recent enhancements",
    ],
  },
  {
    version: "1.0.45-Beta",
    releaseDate: "2026-02-11",
    releaseContent: [
      "feat: Update DateDialog to handle end date for Urlaub and refactor color handling logic",
    ],
  },
  {
    version: "1.0.43-Beta",
    releaseDate: "2026-02-08",
    releaseContent: [
      "feat: Update DateDialog to handle end date for Urlaub and refactor getDefaultColor logic",
    ],
  },
  {
    version: "1.0.41-Beta",
    releaseDate: "2026-01-27",
    releaseContent: [
      "feat: Implement swipe functionality for month change in MyCalendar and enhance date handling in DateDialog",
      "feat: Update Calendar and Footer styles for improved responsiveness and layout adjustments",
    ],
  },
  {
    version: "1.0.35-Beta",
    releaseDate: "2026-01-15",
    releaseContent: [
      "fix: Korrigierte Validierung im DateDialog",
      "Die Validierung im DateDialog wurde verbessert, um sicherzustellen, dass bei der Bearbeitung eines bestehenden Termins keine Fehlermeldungen für bereits vorhandene Start- und Endzeiten angezeigt werden.",
      "feat: Verbesserte Terminbearbeitung im DateDialog",
      "Beim Bearbeiten eines Termins im DateDialog werden die aktuellen Start- und Endzeiten des Termins jetzt korrekt im Formular angezeigt, was die Benutzerfreundlichkeit erhöht.",
      "fix: Korrigierte Berechnung der Urlaubstage im Urlaub-Modal",
      "Im Urlaub-Modal wird die Anzahl der Urlaubstage jetzt korrekt berechnet, indem die Differenz zwischen Start- und Enddatum in Tagen ermittelt wird. Es wird sichergestellt, dass mindestens ein Tag gezählt wird, auch wenn Start- und Enddatum gleich sind.",
      "feat: Verbesserte Anzeige der Schulferien im Schulferien-Modal",
      "Im Schulferien-Modal werden die Schulferien-Termine jetzt gruppiert nach Name und Zeitraum angezeigt. Jeder Eintrag zeigt den Namen der Ferien sowie das Start- und Enddatum an, was die Übersichtlichkeit verbessert.",
    ],
  },
  {
    version: "1.0.29-Beta",
    releaseDate: "2026-01-13",
    releaseContent: [
      "fix: Kalender-Rendering-Probleme behoben und Leistungsverbesserungen implementiert",
      "feat: Update legend items and improve version data structure in calendar",
    ],
  },
  {
    version: "1.0.28-Beta",
    releaseDate: "2026-01-12",
    releaseContent: [
      "feat: Add legend items and enhance calendar functionality with school holidays and versioning",
    ],
  },
  {
    version: "1.0.26",
    releaseDate: "2026-01-10",
    releaseContent: [
      "feat: Enhance calendar functionality with recurring events and weather display",
    ],
  },
  {
    version: "1.0.15",
    releaseDate: "2026-01-07",
    releaseContent: [
      "Add search functionality with overlay and import feature",
      "Implemented a search overlay with a dialog for searching events by title, date, or time.",
      "Added styles for the search overlay and dialog in Search.css.",
      "Created a new Header component to manage the application header, including search and import functionalities.",
      "Developed an Import component for importing events from CSV files or photos, with a preview feature.",
      "Integrated push notification subscription functionality in the Header component.",
      "Enhanced user experience with snackbar notifications for various actions.",
    ],
  },
  {
    version: "1.0.1",
    releaseDate: "2026-01-04",
    releaseContent: ["Initialize project using Create React App"],
  },
];

export default versionData;
